type Rounder = (value: number, countOfNumbers: number) => number;

type ValueToRound = number | undefined | null;

export type ValueFormatter = (value: ValueToRound, defaultValue?: number | string) => string;

type MoneyValueFormatter = (rounder: Rounder, countOfNumbers: number) => ValueFormatter;

export const formatNumberIntl = (value: number, lang: string | undefined = 'ru-RU') => new Intl.NumberFormat(lang).format(value)

/**
 * Метод для округления числа до необходимого числа знаков после запятой
 * @param value
 * @param countOfNumbers
 */
export const roundNumber: Rounder = (value, countOfNumbers) =>
     Math.round(value * 10 ** countOfNumbers) / 10 ** countOfNumbers;

/**
 * Метод для форматирования числа с применением callback для округления
 * @param rounder
 * @param countOfNumbers
 */
export const formatNumberWith: MoneyValueFormatter = (rounder, countOfNumbers) =>
    (value: ValueToRound, defaultValue = 0) =>
        value ? formatNumberIntl(rounder(value, countOfNumbers)) : defaultValue.toString();

/**
 * Метод для форматирования числа с двумя знаками после запятой
 */
export const formatNumber2d = formatNumberWith(roundNumber, 2);
